var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20C17.5 17.643 17.5 16.4645 18.2323 15.7323C18.9645 15 20.143 15 22.5 15C24.857 15 26.0355 15 26.7677 15.7323C27.5 16.4645 27.5 17.643 27.5 20C27.5 22.357 27.5 23.5355 26.7677 24.2677C26.0355 25 24.857 25 22.5 25C20.143 25 18.9645 25 18.2323 24.2677C17.5 23.5355 17.5 22.357 17.5 20Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20V14.8283C17.5 10.2446 20.6446 6.3573 25 5",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 20C2.5 17.643 2.5 16.4645 3.23224 15.7323C3.96446 15 5.14298 15 7.5 15C9.85702 15 11.0355 15 11.7678 15.7323C12.5 16.4645 12.5 17.643 12.5 20C12.5 22.357 12.5 23.5355 11.7678 24.2677C11.0355 25 9.85702 25 7.5 25C5.14298 25 3.96446 25 3.23224 24.2677C2.5 23.5355 2.5 22.357 2.5 20Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 20V14.8283C2.5 10.2446 5.64464 6.3573 10 5",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.0dc415091c38d93b2b0bc07e8ecd930d.svg";
export { ForwardRef as ReactComponent };